var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.285645 30.8386C0.285645 14.2702 13.5891 0.838562 29.9999 0.838562C46.4107 0.838562 59.7142 14.2702 59.7142 30.8386C59.7142 47.4071 46.4107 60.8386 29.9999 60.8386C13.5891 60.8386 0.285645 47.4071 0.285645 30.8386ZM35.8164 29.7338C33.982 29.837 32.4898 29.6802 30.9978 29.5234C29.5058 29.3666 28.0137 29.21 26.1791 29.313C25.2988 29.3626 24.3652 29.4878 23.4782 29.6976C24.019 23.0809 28.8217 17.2917 35.3528 16.9244C39.3605 16.6988 43.3658 19.112 43.5836 23.0288C43.7972 26.8786 40.7865 29.4541 35.8164 29.7338ZM25.9922 43.6821C22.1954 43.889 18.4008 41.6769 18.1947 38.0864C17.992 34.5574 20.8444 32.1966 25.5527 31.9402C27.2907 31.8456 28.7043 31.9893 30.1179 32.133C31.5315 32.2768 32.9452 32.4205 34.6831 32.3258C35.5173 32.2805 36.4016 32.1656 37.2419 31.9732C36.7296 38.0386 32.1794 43.3453 25.9922 43.6821Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLight);
export default __webpack_public_path__ + "static/media/status_light.82b6a671.svg";
export { ForwardRef as ReactComponent };